import {
  REGISTER_FINAL,
  REGISTER_FINAL_SUCCESS,
  REGISTER_FINAL_FAILURE,
} from 'store/registerFinal/registerFinalAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const registerFinalReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_FINAL:
      return { ...state, loading: true };
    case REGISTER_FINAL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case REGISTER_FINAL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default registerFinalReducer;
